// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoginResponse } from './models/login-response';

@Injectable({
  providedIn: 'root',
})
export class TokenProviderService {
  private _token: string = null;
  /**
   * Getter para o token da API
   */
  public get token(): string {
    return this._token;
  }

  /**
   * Retorna se o token da API é válido
   */
  public get valid(): boolean {
    return this._token !== null;
  }

  private _currentUser: LoginResponse = null;
  /**
   * Retorna o usuário logado atualmente ou null
   */
  public get currentUser(): LoginResponse {
    return this._currentUser;
  }
  /**
   * Define o usuário logado atualmente
   */
  public set currentUser(value: LoginResponse) {
    this._currentUser = value;
    this._token = value ? value.accessToken : null;
    this._user.next(value);
  }

  private _user = new Subject<LoginResponse>();
  /**
   * Um subject que emitirá um novo valor a cada login
   */
  public get user(): Subject<LoginResponse> {
    return this._user;
  }
}
